import { useCountryAutocompleteT } from "src/translation-hooks/country-autocomplete";
import { Shared_Countries as Countries } from "src/backend/openapi/v1";
import { useCallback } from "react";

export const useCountryTranslation = () => {
  const t = useCountryAutocompleteT();

  const getCountryTranslation = useCallback(
    (value: string | Countries) => {
      const enumValue: Countries = typeof value === "string" ? parseInt(value) : value;
      switch (enumValue) {
        case Countries.Afghanistan:
          return t.afghanistan;

        case Countries.Albania:
          return t.albania;

        case Countries.Algeria:
          return t.algeria;

        case Countries.Andorra:
          return t.andorra;

        case Countries.Angola:
          return t.angola;

        case Countries.AntiguaandBarbuda:
          return t.antiguaandBarbuda;

        case Countries.Argentina:
          return t.argentina;

        case Countries.Armenia:
          return t.armenia;

        case Countries.Australia:
          return t.australia;

        case Countries.Austria:
          return t.austria;

        case Countries.Azerbaijan:
          return t.azerbaijan;

        case Countries.Bahamas:
          return t.bahamas;

        case Countries.Bahrain:
          return t.bahrain;

        case Countries.Bangladesh:
          return t.bangladesh;

        case Countries.Barbados:
          return t.barbados;

        case Countries.Belarus:
          return t.belarus;

        case Countries.Belgium:
          return t.belgium;

        case Countries.Belize:
          return t.belize;

        case Countries.Benin:
          return t.benin;

        case Countries.Bhutan:
          return t.bhutan;

        case Countries.Bolivia:
          return t.bolivia;

        case Countries.BosniaandHerzegovina:
          return t.bosniaandHerzegovina;

        case Countries.Botswana:
          return t.botswana;

        case Countries.Brazil:
          return t.brazil;

        case Countries.Brunei:
          return t.brunei;

        case Countries.Bulgaria:
          return t.bulgaria;

        case Countries.BurkinaFaso:
          return t.burkinaFaso;

        case Countries.Burundi:
          return t.burundi;

        case Countries.Cambodia:
          return t.cambodia;

        case Countries.Cameroon:
          return t.cameroon;

        case Countries.Canada:
          return t.canada;

        case Countries.CapeVerde:
          return t.capeVerde;

        case Countries.CentralAfricanRepublic:
          return t.centralAfricanRepublic;

        case Countries.Chad:
          return t.chad;

        case Countries.Chile:
          return t.chile;

        case Countries.China:
          return t.china;

        case Countries.Colombia:
          return t.colombia;

        case Countries.Comoros:
          return t.comoros;

        case Countries.CostaRica:
          return t.costaRica;

        case Countries.Croatia:
          return t.croatia;

        case Countries.Cuba:
          return t.cuba;

        case Countries.Cyprus:
          return t.cyprus;

        case Countries.CzechRepublic:
          return t.czechRepublic;

        case Countries.DemocraticRepublicoftheCongo:
          return t.democraticRepublicoftheCongo;

        case Countries.Denmark:
          return t.denmark;

        case Countries.Djibouti:
          return t.djibouti;

        case Countries.Dominica:
          return t.dominica;

        case Countries.DominicanRepublic:
          return t.dominicanRepublic;

        case Countries.EastTimor:
          return t.eastTimor;

        case Countries.Ecuador:
          return t.ecuador;

        case Countries.Egypt:
          return t.egypt;

        case Countries.ElSalvador:
          return t.elSalvador;

        case Countries.EquatorialGuinea:
          return t.equatorialGuinea;

        case Countries.Eritrea:
          return t.eritrea;

        case Countries.Estonia:
          return t.estonia;

        case Countries.Ethiopia:
          return t.ethiopia;

        case Countries.FaroeIslands:
          return t.faroeIslands;

        case Countries.Fiji:
          return t.fiji;

        case Countries.Finland:
          return t.finland;

        case Countries.France:
          return t.france;

        case Countries.Gabon:
          return t.gabon;

        case Countries.Gambia:
          return t.gambia;

        case Countries.Georgia:
          return t.georgia;

        case Countries.Germany:
          return t.germany;

        case Countries.Ghana:
          return t.ghana;

        case Countries.Greece:
          return t.greece;

        case Countries.Greenland:
          return t.greenland;

        case Countries.Grenada:
          return t.grenada;

        case Countries.Guatemala:
          return t.guatemala;

        case Countries.Guinea:
          return t.guinea;

        case Countries.GuineaBissau:
          return t.guineaBissau;

        case Countries.Guyana:
          return t.guyana;

        case Countries.Haiti:
          return t.haiti;

        case Countries.Honduras:
          return t.honduras;

        case Countries.Hungary:
          return t.hungary;

        case Countries.Iceland:
          return t.iceland;

        case Countries.India:
          return t.india;

        case Countries.Indonesia:
          return t.indonesia;

        case Countries.Iran:
          return t.iran;

        case Countries.Iraq:
          return t.iraq;

        case Countries.Ireland:
          return t.ireland;

        case Countries.Israel:
          return t.israel;

        case Countries.Italy:
          return t.italy;

        case Countries.IvoryCoast:
          return t.ivoryCoast;

        case Countries.Jamaica:
          return t.jamaica;

        case Countries.Japan:
          return t.japan;

        case Countries.Jordan:
          return t.jordan;

        case Countries.Kazakhstan:
          return t.kazakhstan;

        case Countries.Kenya:
          return t.kenya;

        case Countries.Kiribati:
          return t.kiribati;

        case Countries.Kuwait:
          return t.kuwait;

        case Countries.Kyrgyzstan:
          return t.kyrgyzstan;

        case Countries.Laos:
          return t.laos;

        case Countries.Latvia:
          return t.latvia;

        case Countries.Lebanon:
          return t.lebanon;

        case Countries.Lesotho:
          return t.lesotho;

        case Countries.Liberia:
          return t.liberia;

        case Countries.Libya:
          return t.libya;

        case Countries.Liechtenstein:
          return t.liechtenstein;

        case Countries.Lithuania:
          return t.lithuania;

        case Countries.Luxembourg:
          return t.luxembourg;

        case Countries.Macedonia:
          return t.macedonia;

        case Countries.Madagascar:
          return t.madagascar;

        case Countries.Malawi:
          return t.malawi;

        case Countries.Malaysia:
          return t.malaysia;

        case Countries.Maldives:
          return t.maldives;

        case Countries.Mali:
          return t.mali;

        case Countries.Malta:
          return t.malta;

        case Countries.MarshallIslands:
          return t.marshallIslands;

        case Countries.Mauritania:
          return t.mauritania;

        case Countries.Mauritius:
          return t.mauritius;

        case Countries.Mexico:
          return t.mexico;

        case Countries.Micronesia:
          return t.micronesia;

        case Countries.Moldova:
          return t.moldova;

        case Countries.Monaco:
          return t.monaco;

        case Countries.Mongolia:
          return t.mongolia;

        case Countries.Montenegro:
          return t.montenegro;

        case Countries.Morocco:
          return t.morocco;

        case Countries.Mozambique:
          return t.mozambique;

        case Countries.Myanmar:
          return t.myanmar;

        case Countries.Namibia:
          return t.namibia;

        case Countries.Nauru:
          return t.nauru;

        case Countries.Nepal:
          return t.nepal;

        case Countries.Netherlands:
          return t.netherlands;

        case Countries.NewZealand:
          return t.newZealand;

        case Countries.Nicaragua:
          return t.nicaragua;

        case Countries.Niger:
          return t.niger;

        case Countries.Nigeria:
          return t.nigeria;

        case Countries.NorthKorea:
          return t.northKorea;

        case Countries.Norway:
          return t.norway;

        case Countries.Oman:
          return t.oman;

        case Countries.Pakistan:
          return t.pakistan;

        case Countries.Palau:
          return t.palau;

        case Countries.Panama:
          return t.panama;

        case Countries.PapuaNewGuinea:
          return t.papuaNewGuinea;

        case Countries.Paraguay:
          return t.paraguay;

        case Countries.Peru:
          return t.peru;

        case Countries.Philippines:
          return t.philippines;

        case Countries.Poland:
          return t.poland;

        case Countries.Portugal:
          return t.portugal;

        case Countries.Qatar:
          return t.qatar;

        case Countries.RepublicoftheCongo:
          return t.republicoftheCongo;

        case Countries.Romania:
          return t.romania;

        case Countries.Russia:
          return t.russia;

        case Countries.Rwanda:
          return t.rwanda;

        case Countries.SaintKittsandNevis:
          return t.saintKittsandNevis;

        case Countries.SaintLucia:
          return t.saintLucia;

        case Countries.SaintVincentandtheGrenadines:
          return t.saintVincentandtheGrenadines;

        case Countries.Samoa:
          return t.samoa;

        case Countries.SanMarino:
          return t.sanMarino;

        case Countries.SaoTomeandPrincipe:
          return t.saoTomeandPrincipe;

        case Countries.SaudiArabia:
          return t.saudiArabia;

        case Countries.Senegal:
          return t.senegal;

        case Countries.Serbia:
          return t.serbia;

        case Countries.Seychelles:
          return t.seychelles;

        case Countries.SierraLeone:
          return t.sierraLeone;

        case Countries.Singapore:
          return t.singapore;

        case Countries.Slovakia:
          return t.slovakia;

        case Countries.Slovenia:
          return t.slovenia;

        case Countries.SolomonIslands:
          return t.solomonIslands;

        case Countries.Somalia:
          return t.somalia;

        case Countries.SouthAfrica:
          return t.southAfrica;

        case Countries.SouthKorea:
          return t.southKorea;

        case Countries.SouthSudan:
          return t.southSudan;

        case Countries.Spain:
          return t.spain;

        case Countries.SriLanka:
          return t.sriLanka;

        case Countries.Sudan:
          return t.sudan;

        case Countries.Suriname:
          return t.suriname;

        case Countries.Swaziland:
          return t.swaziland;

        case Countries.Sweden:
          return t.sweden;

        case Countries.Switzerland:
          return t.switzerland;

        case Countries.Syria:
          return t.syria;

        case Countries.Tajikistan:
          return t.tajikistan;

        case Countries.Tanzania:
          return t.tanzania;

        case Countries.Thailand:
          return t.thailand;

        case Countries.Togo:
          return t.togo;

        case Countries.Tonga:
          return t.tonga;

        case Countries.TrinidadandTobago:
          return t.trinidadandTobago;

        case Countries.Tunisia:
          return t.tunisia;

        case Countries.Turkey:
          return t.turkey;

        case Countries.Turkmenistan:
          return t.turkmenistan;

        case Countries.Tuvalu:
          return t.tuvalu;

        case Countries.Uganda:
          return t.uganda;

        case Countries.Ukraine:
          return t.ukraine;

        case Countries.UnitedArabEmirates:
          return t.unitedArabEmirates;

        case Countries.UnitedKingdom:
          return t.unitedKingdom;

        case Countries.UnitedStates:
          return t.unitedStates;

        case Countries.Uruguay:
          return t.uruguay;

        case Countries.Uzbekistan:
          return t.uzbekistan;

        case Countries.Vanuatu:
          return t.vanuatu;

        case Countries.Vatican:
          return t.vatican;

        case Countries.Venezuela:
          return t.venezuela;

        case Countries.Vietnam:
          return t.vietnam;

        case Countries.Yemen:
          return t.yemen;

        case Countries.Zambia:
          return t.zambia;

        case Countries.Zimbabwe:
          return t.zimbabwe;

        case Countries.CaymanIslands:
          return t.caymanIslands;

        case Countries.HongKong:
          return t.hongKong;

        case Countries.Macau:
          return t.macau;

        case Countries.NorthMacedonia:
          return t.northMacedonia;

        case Countries.Yugoslavia:
          return t.yugoslavia;

        case Countries.Taiwan:
          return t.taiwan;

        default:
          return "";
      }
    },

    [t]
  );

  const getCountryCode = useCallback((country: Countries) => {
    switch (country) {
      case Countries.Afghanistan:
        return "AF";

      case Countries.Albania:
        return "AL";

      case Countries.Algeria:
        return "DZ";

      case Countries.Andorra:
        return "AD";

      case Countries.Angola:
        return "AO";

      case Countries.AntiguaandBarbuda:
        return "AG";

      case Countries.Argentina:
        return "AR";

      case Countries.Armenia:
        return "AM";

      case Countries.Australia:
        return "AU";

      case Countries.Austria:
        return "AT";

      case Countries.Azerbaijan:
        return "AZ";

      case Countries.Bahamas:
        return "BS";

      case Countries.Bahrain:
        return "BH";

      case Countries.Bangladesh:
        return "BD";

      case Countries.Barbados:
        return "BB";

      case Countries.Belarus:
        return "BY";

      case Countries.Belgium:
        return "BE";

      case Countries.Belize:
        return "BZ";

      case Countries.Benin:
        return "BJ";

      case Countries.Bhutan:
        return "BT";

      case Countries.Bolivia:
        return "BO";

      case Countries.BosniaandHerzegovina:
        return "BA";

      case Countries.Botswana:
        return "BW";

      case Countries.Brazil:
        return "BR";

      case Countries.Brunei:
        return "BN";

      case Countries.Bulgaria:
        return "BG";

      case Countries.BurkinaFaso:
        return "BF";

      case Countries.Burundi:
        return "BI";

      case Countries.Cambodia:
        return "KH";

      case Countries.Cameroon:
        return "CM";

      case Countries.Canada:
        return "CA";

      case Countries.CapeVerde:
        return "CV";

      case Countries.CentralAfricanRepublic:
        return "CF";

      case Countries.Chad:
        return "TD";

      case Countries.Chile:
        return "CL";

      case Countries.China:
        return "CN";

      case Countries.Colombia:
        return "CO";

      case Countries.Comoros:
        return "KM";

      case Countries.CostaRica:
        return "CR";

      case Countries.Croatia:
        return "HR";

      case Countries.Cuba:
        return "CU";

      case Countries.Cyprus:
        return "CY";

      case Countries.CzechRepublic:
        return "CZ";

      case Countries.DemocraticRepublicoftheCongo:
        return "CD";

      case Countries.Denmark:
        return "DK";

      case Countries.Djibouti:
        return "DJ";

      case Countries.Dominica:
        return "DM";

      case Countries.DominicanRepublic:
        return "DO";

      case Countries.EastTimor:
        return "TL";

      case Countries.Ecuador:
        return "EC";

      case Countries.Egypt:
        return "EG";

      case Countries.ElSalvador:
        return "SV";

      case Countries.EquatorialGuinea:
        return "GQ";

      case Countries.Eritrea:
        return "ER";

      case Countries.Estonia:
        return "EE";

      case Countries.Ethiopia:
        return "ET";

      case Countries.Fiji:
        return "FJ";

      case Countries.Finland:
        return "FI";

      case Countries.France:
        return "FR";

      case Countries.Gabon:
        return "GA";

      case Countries.Gambia:
        return "GM";

      case Countries.Georgia:
        return "GE";

      case Countries.Germany:
        return "DE";

      case Countries.Ghana:
        return "GH";

      case Countries.Greece:
        return "GR";

      case Countries.Grenada:
        return "GD";

      case Countries.Guatemala:
        return "GT";

      case Countries.Guinea:
        return "GN";

      case Countries.GuineaBissau:
        return "GW";

      case Countries.Guyana:
        return "GY";

      case Countries.Haiti:
        return "HT";

      case Countries.Honduras:
        return "HN";

      case Countries.Hungary:
        return "HU";

      case Countries.Iceland:
        return "IS";

      case Countries.India:
        return "IN";

      case Countries.Indonesia:
        return "ID";

      case Countries.Iran:
        return "IR";

      case Countries.Iraq:
        return "IQ";

      case Countries.Ireland:
        return "IE";

      case Countries.Israel:
        return "IL";

      case Countries.Italy:
        return "IT";

      case Countries.IvoryCoast:
        return "CI";

      case Countries.Jamaica:
        return "JM";

      case Countries.Japan:
        return "JP";

      case Countries.Jordan:
        return "JO";

      case Countries.Kazakhstan:
        return "KZ";

      case Countries.Kenya:
        return "KE";

      case Countries.Kiribati:
        return "KI";

      case Countries.Kuwait:
        return "KW";

      case Countries.Kyrgyzstan:
        return "KG";

      case Countries.Laos:
        return "LA";

      case Countries.Latvia:
        return "LV";

      case Countries.Lebanon:
        return "LB";

      case Countries.Lesotho:
        return "LS";

      case Countries.Liberia:
        return "LR";

      case Countries.Libya:
        return "LY";

      case Countries.Liechtenstein:
        return "LI";

      case Countries.Lithuania:
        return "LT";

      case Countries.Luxembourg:
        return "LU";

      case Countries.Macedonia:
        return "MK";

      case Countries.Madagascar:
        return "MG";

      case Countries.Malawi:
        return "MW";

      case Countries.Malaysia:
        return "MY";

      case Countries.Maldives:
        return "MV";

      case Countries.Mali:
        return "ML";

      case Countries.Malta:
        return "MT";

      case Countries.MarshallIslands:
        return "MH";

      case Countries.Mauritania:
        return "MR";

      case Countries.Mauritius:
        return "MU";

      case Countries.Mexico:
        return "MX";

      case Countries.Micronesia:
        return "FM";

      case Countries.Moldova:
        return "MD";

      case Countries.Monaco:
        return "MC";

      case Countries.Mongolia:
        return "MN";

      case Countries.Montenegro:
        return "ME";

      case Countries.Morocco:
        return "MA";

      case Countries.Mozambique:
        return "MZ";

      case Countries.Myanmar:
        return "MM";

      case Countries.Namibia:
        return "NA";

      case Countries.Nauru:
        return "NR";

      case Countries.Nepal:
        return "NP";

      case Countries.Netherlands:
        return "NL";

      case Countries.NewZealand:
        return "NZ";

      case Countries.Nicaragua:
        return "NI";

      case Countries.Niger:
        return "NE";

      case Countries.Nigeria:
        return "NG";

      case Countries.NorthKorea:
        return "KP";

      case Countries.Norway:
        return "NO";

      case Countries.Oman:
        return "OM";

      case Countries.Pakistan:
        return "PK";

      case Countries.Palau:
        return "PW";

      case Countries.Panama:
        return "PA";

      case Countries.PapuaNewGuinea:
        return "PG";

      case Countries.Paraguay:
        return "PY";

      case Countries.Peru:
        return "PE";

      case Countries.Philippines:
        return "PH";

      case Countries.Poland:
        return "PL";

      case Countries.Portugal:
        return "PT";

      case Countries.Qatar:
        return "QA";

      case Countries.RepublicoftheCongo:
        return "CG";

      case Countries.Romania:
        return "RO";

      case Countries.Russia:
        return "RU";

      case Countries.Rwanda:
        return "RW";

      case Countries.SaintKittsandNevis:
        return "KN";

      case Countries.SaintLucia:
        return "LC";

      case Countries.SaintVincentandtheGrenadines:
        return "VC";

      case Countries.Samoa:
        return "WS";

      case Countries.SanMarino:
        return "SM";

      case Countries.SaoTomeandPrincipe:
        return "ST";

      case Countries.SaudiArabia:
        return "SA";

      case Countries.Senegal:
        return "SN";

      case Countries.Serbia:
        return "RS";

      case Countries.Seychelles:
        return "SC";

      case Countries.SierraLeone:
        return "SL";

      case Countries.Singapore:
        return "SG";

      case Countries.Slovakia:
        return "SK";

      case Countries.Slovenia:
        return "SI";

      case Countries.SolomonIslands:
        return "SB";

      case Countries.Somalia:
        return "SO";

      case Countries.SouthAfrica:
        return "ZA";

      case Countries.SouthKorea:
        return "KR";

      case Countries.SouthSudan:
        return "SS";

      case Countries.Spain:
        return "ES";

      case Countries.SriLanka:
        return "LK";

      case Countries.Sudan:
        return "SD";

      case Countries.Suriname:
        return "SR";

      case Countries.Swaziland:
        return "SZ";

      case Countries.Sweden:
        return "SE";

      case Countries.Switzerland:
        return "CH";

      case Countries.Syria:
        return "SY";

      case Countries.Tajikistan:
        return "TJ";

      case Countries.Tanzania:
        return "TZ";

      case Countries.Thailand:
        return "TH";

      case Countries.Togo:
        return "TG";

      case Countries.Tonga:
        return "TO";

      case Countries.TrinidadandTobago:
        return "TT";

      case Countries.Tunisia:
        return "TN";

      case Countries.Turkey:
        return "TR";

      case Countries.Turkmenistan:
        return "TM";

      case Countries.Tuvalu:
        return "TV";

      case Countries.Uganda:
        return "UG";

      case Countries.Ukraine:
        return "UA";

      case Countries.UnitedArabEmirates:
        return "AE";

      case Countries.UnitedKingdom:
        return "GB";

      case Countries.UnitedStates:
        return "US";

      case Countries.Uruguay:
        return "UY";

      case Countries.Uzbekistan:
        return "UZ";

      case Countries.Vanuatu:
        return "VU";

      case Countries.Vatican:
        return "VA";

      case Countries.Venezuela:
        return "VE";

      case Countries.Vietnam:
        return "VN";

      case Countries.Yemen:
        return "YE";

      case Countries.Zambia:
        return "ZM";

      case Countries.Zimbabwe:
        return "ZW";

      case Countries.FaroeIslands:
        return "FO";

      case Countries.Greenland:
        return "GL";

      case Countries.CaymanIslands:
        return "KY";

      case Countries.HongKong:
      case Countries.Macau:
        return "ZH";

      case Countries.NorthMacedonia:
        return "MK";

      case Countries.Yugoslavia:
        return "YU";

      case Countries.Taiwan:
        return "TW";

      default:
        return "";
    }
  }, []);

  return { getCountryTranslation, getCountryCode };
};
